import React from "react";
import { Modal } from "react-bootstrap";
import basePath from "../utils/basePath";

class ShareModal extends React.Component {
  state = {
    show: false,
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  handleShow = (e) => {
    this.setState({ show: true });
    // if (window.CHASE) {
    //   window.CHASE.analytics.trackModalLoad(
    //     "cf-example-modal",
    //     `cf-${this.props.modalId}s-modal`
    //   );
    // }
  };
  iconHelper = () => {
    let iconHTML = "";
    if (this.props.iconClass) {
      iconHTML = <i className={this.props.iconClass} aria-hidden="true"></i>;
    }
    return iconHTML;
  };
  trackSocial = (network) => {
    if (window.ga) {
      window.ga("send", "event", "Actions", "Click", `${network} share`);
    }
  };
  render() {
    return (
      <>
        <button type="button" onClick={this.handleShow} className={this.props.buttonClass} data-pt-name={this.props.dataptname}>
          {this.iconHelper()}
          <br />
          {this.props.label}
        </button>

        <Modal size="lg" show={this.state.show} className={`${this.props.modalId}-modal avatar-modal`} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title as="h2">How did you 2020?</Modal.Title>
            <button
              type="button"
              className="close"
              //data-pt-name={`${this.props.dataptname}_x-button`}
              onClick={this.handleClose}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row pb-5">
                <div className="col-xs-12">
                  <div className="mr-3 mb-2">
                    <strong>SHARE TO</strong>
                  </div>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin + window.location.pathname}`}
                    className="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => this.trackSocial("Facebook")}
                    //data-pt-name={`${this.props.dataptname}_facebook-share`}
                  >
                    <span className="sr-only">Share on facebook</span>
                    <i className="fa fa-facebook-official"></i>
                  </a>
                  <a
                    href={`https://twitter.com/intent/tweet?text=Build%20your%20very%20own%202020%20avatar%20that%20best%20describes%20YOU%20this%20past%20year%20and%20your%20methods%20for%20getting%20through%20the%20madness. ${
                      window.location.origin + window.location.pathname
                    }`}
                    className="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => this.trackSocial("Twitter")}
                    //data-pt-name={`${this.props.dataptname}_twitter-share`}
                  >
                    <span className="sr-only">Share on twitter</span>
                    <i className="fa fa-twitter"></i>
                  </a>
                  <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.origin + window.location.pathname}`}
                    className="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => this.trackSocial("LinkedIn")}
                    //data-pt-name={`${this.props.dataptname}_twitter-share`}
                  >
                    <span className="sr-only">Share on LinkedIn</span>
                    <i className="fa fa-linkedin"></i>
                  </a>
                  <a
                    href="mailto:?subject=How%20did%20you%202020?&body=Build your very own 2020 avatar that best describes YOU this past year and your methods for getting through the madness. http://millenniumweb.com/2020"
                    className="social-icon"
                    onClick={() => this.trackSocial("Email")}
                    //data-pt-name={`${this.props.dataptname}_email-share`}
                  >
                    <span className="sr-only">Share by email</span>
                    <i className="fa fa-envelope"></i>
                  </a>
                  <div className="container-fluid share-preview">
                    <div className="row no-gutters mt-5 border border-dark">
                      <div className="col-xs-12 col-md-6 p-0">
                        <img src={`${basePath}images/og-how-did-you-2020.jpg`} className="fit-image" alt="" />
                      </div>
                      <div className="col-xs-12 col-md-6 p-3">
                        <p>Build your very own 2020 avatar that best describes YOU this past year and your methods for getting through the madness.</p>
                        <p>millenniumweb.com/2020</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default ShareModal;
